function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.091 23.073a1.73 1.73 0 010-3.458c.954 0 1.73.775 1.73 1.729v.002a1.73 1.73 0 01-1.73 1.727zm0-5.073a3.348 3.348 0 00-3.344 3.344c0 1.843 1.5 3.343 3.344 3.343.655 0 1.267-.192 1.783-.52a.806.806 0 001.56-.284v-2.54c0-1.843-1.499-3.343-3.343-3.343zM50.761 23.073c-.953 0-1.729-.776-1.729-1.73 0-.953.776-1.728 1.73-1.728.953 0 1.73.775 1.73 1.729v.002a1.732 1.732 0 01-1.73 1.727zm0-5.073a3.347 3.347 0 00-3.342 3.344c0 1.843 1.5 3.343 3.343 3.343.656 0 1.266-.192 1.783-.52a.805.805 0 001.56-.284v-2.54c0-1.843-1.499-3.343-3.343-3.343zM56.246 15a.808.808 0 00-.808.807v8.385a.807.807 0 001.615 0v-8.385a.807.807 0 00-.807-.807zM45.42 15a.807.807 0 00-.807.807v8.385a.807.807 0 001.615 0v-8.385A.808.808 0 0045.42 15z",
  fill: "#FF7E00"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M58.371 18h1.613v6.713h-1.613V18z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#hello-ralali_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59.178 18a.807.807 0 00-.807.807v5.1a.807.807 0 001.613 0v-5.1a.807.807 0 00-.806-.807z",
  fill: "#FF7E00"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59.177 17.26a.809.809 0 00.571-1.377.806.806 0 10-.571 1.377z",
  fill: "#FF7E00"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M35.449 23.022l-.005-.436c0-.162-.018-.32-.054-.477-.14-.634-.225-1.003-.688-1.453a3.46 3.46 0 00.738-2.447 3.476 3.476 0 00-3.198-3.198 3.494 3.494 0 00-3.774 3.41v5.316c0 .612.494 1.107 1.106 1.107h.49a.226.226 0 00.225-.225V21.56a3.478 3.478 0 002.803.243 1.493 1.493 0 01.553 1.178c0 .023 0 .05.004.077v.657c0 .63.513 1.142 1.143 1.142h.45c.126 0 .23-.103.225-.23l-.018-1.605zm-5.146-4.426a1.66 1.66 0 011.763-1.763c.823.054 1.493.72 1.547 1.547a1.66 1.66 0 01-1.763 1.763 1.671 1.671 0 01-1.547-1.547z",
  fill: "#FF7E00"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0h25.41v26.12H0V0z",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#hello-ralali_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.704 0C5.688 0 0 5.688 0 12.704c0 2.99 1.04 5.733 2.772 7.903.701.877 1.064 2.276.424 3.103-.456.591-.96.997-1.504 1.068-1.766.238.651 2.355 4.799.739 1.044-.408 2.67-.57 3.771-.349.79.157 1.608.242 2.444.242 7.016 0 12.704-5.688 12.704-12.704C25.41 5.688 19.722 0 12.704 0z",
  fill: "#FF7E00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.992 17.26l-.006-.618c0-.229-.026-.451-.077-.674-.197-.898-.318-1.42-.974-2.056a4.894 4.894 0 001.044-3.463 4.92 4.92 0 00-4.526-4.526 4.944 4.944 0 00-5.34 4.825v7.524c0 .866.7 1.566 1.566 1.566h.693a.32.32 0 00.319-.318V15.19a4.922 4.922 0 003.965.344c.064.05.128.108.185.172.35.35.598.878.598 1.496 0 .032 0 .07.007.108v.93a1.62 1.62 0 001.617 1.616h.636a.317.317 0 00.318-.325l-.025-2.272zm-7.282-6.264a2.349 2.349 0 012.495-2.495 2.36 2.36 0 012.19 2.19 2.349 2.349 0 01-2.495 2.495 2.365 2.365 0 01-2.19-2.19z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.078 5.897a4.935 4.935 0 00-4.972 4.94 1.293 1.293 0 002.585 0h.012a2.344 2.344 0 012.343-2.342h.032v-.013a1.293 1.293 0 000-2.585zM16.706 9.545c-.713 0-1.292.58-1.292 1.292h-.013a2.344 2.344 0 01-2.342 2.343h-.032v.012a1.293 1.293 0 000 2.585 4.935 4.935 0 004.971-4.94c0-.713-.579-1.292-1.292-1.292z",
  fill: "#fff"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.29 12.352c-.568-.005-.952-.296-1.154-.87-.201-.574-.302-1.49-.302-2.748 0-1.884.102-3.782.307-5.695.122-1.166.374-2.021.754-2.567.198-.287.435-.431.71-.431.017 0 .103.004.258.013.155.009.32.174.495.495.258.471.395 1.356.412 2.654l.01 1.146c0 .086.017.159.052.22.035.06.157.09.368.09l1.963.026c.065 0 .12-.13.167-.388.17-.879.298-1.473.386-1.783.099-.374.26-.69.482-.948.193-.23.417-.345.675-.345.029 0 .122.01.28.03.158.02.321.171.49.453.217.356.325.953.325 1.792 0 1.212-.006 2.223-.017 3.032-.041 1.901-.199 3.108-.474 3.619-.222.425-.575.637-1.06.637-.514 0-.871-.227-1.07-.68-.134-.305-.201-.965-.201-1.982 0-.5-.012-.886-.035-1.159-.024-.272-.097-.409-.22-.409-1.302.04-1.986.07-2.05.09-.065.02-.106.071-.123.151-.03.133-.044.61-.044 1.43 0 1.442-.079 2.52-.237 3.231a1.106 1.106 0 01-.416.655c-.213.16-.457.241-.732.241zM39.987 6.873c.391 0 .695-.21.912-.629.152-.299.227-.531.227-.698 0-.149-.075-.224-.227-.224l-.14.005c-.088.003-.246.067-.474.193-.228.127-.42.28-.578.457-.13.144-.193.287-.193.43 0 .31.157.466.473.466zm.605 4.635h-.079c-.648 0-1.193-.145-1.634-.435a2.815 2.815 0 01-1.013-1.176 4.191 4.191 0 01-.377-1.792c0-.85.152-1.57.456-2.162.304-.592.701-1.037 1.192-1.336.491-.298.994-.448 1.508-.448.526.006.978.158 1.358.457.427.344.64.844.64 1.499 0 .425-.127.794-.381 1.107-.254.313-.606.561-1.056.745-.45.184-.93.308-1.438.37-.304.04-.456.228-.456.56 0 .19.088.391.264.604.192.235.566.353 1.121.353.637 0 1.274-.181 1.911-.543.34-.195.625-.293.86-.293.157 0 .278.05.363.147a.51.51 0 01.127.344.86.86 0 01-.28.63c-.906.895-1.935 1.352-3.086 1.369zM45.488 12.352h-.053c-.21 0-.41-.069-.6-.207a.921.921 0 01-.364-.577c-.134-.66-.201-2.412-.201-5.255 0-2.837.07-4.58.21-5.23.064-.287.207-.49.43-.611a.855.855 0 01.42-.112c.093 0 .187.014.28.043a.942.942 0 01.64.612c.21.631.366 1.671.465 3.118.082 1.132.123 2.263.123 3.395 0 .316-.009.914-.026 1.796-.018.882-.138 1.641-.36 2.279-.164.482-.485.732-.964.75zM49.323 12.352h-.053c-.21 0-.41-.069-.6-.207a.921.921 0 01-.364-.577c-.134-.66-.201-2.412-.201-5.255 0-2.837.07-4.58.21-5.23.064-.287.207-.49.43-.611a.854.854 0 01.42-.112c.093 0 .187.014.28.043a.942.942 0 01.64.612c.21.631.366 1.671.465 3.118.082 1.132.123 2.263.123 3.395 0 .316-.01.914-.026 1.796-.018.882-.138 1.641-.36 2.279-.164.482-.485.732-.964.75zM54.122 9.94c.321-.017.587-.193.798-.526.21-.333.315-.706.315-1.12a1.72 1.72 0 00-.166-.74c-.246-.517-.634-.776-1.166-.776a.655.655 0 00-.579.328c-.187.292-.28.672-.28 1.137 0 .2.028.432.083.693.056.262.167.494.333.698a.768.768 0 00.618.306h.044zm.044 2.007h-.079c-.648-.017-1.172-.188-1.569-.512a2.775 2.775 0 01-.867-1.263 4.889 4.889 0 01-.272-1.628c0-.603.089-1.184.267-1.744.178-.56.463-1.018.855-1.374.42-.38.967-.57 1.639-.57.391 0 .81.125 1.253.371.555.316.972.766 1.25 1.349.277.583.416 1.216.416 1.9 0 1.01-.328 1.86-.982 2.55-.59.614-1.227.921-1.91.921z",
  fill: "#FBAF05"
});

function SvgHelloRalali(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, /*#__PURE__*/React.createElement("mask", {
    id: "hello-ralali_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 18,
    width: 2,
    height: 7
  }, _ref2), _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("mask", {
    id: "hello-ralali_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 27
  }, _ref6), _ref7, _ref8);
}

export default SvgHelloRalali;